import { createFileRoute, redirect } from "@tanstack/react-router";
import FeatureFlagsPage from "@/pages/FeatureFlagsPage";
import { isAdminBuild } from "@/utils/isAdminBuild";

export const Route = createFileRoute(
  "/$leaid/_error-wrapper/admin/site-administration/feature-flags"
)({
  beforeLoad: ({ context, params }) => {
    if (
      !isAdminBuild() ||
      params.leaid !== "0-" ||
      !context.hasRole("ADMIN")
    ) {
      throw redirect({ to: "/$leaid", params: { leaid: params.leaid } });
    }
  },
  component: FeatureFlagsPage,
});
